import { render, staticRenderFns } from "./ClientBidOrBuy.vue?vue&type=template&id=67408dca&scoped=true&"
import script from "./ClientBidOrBuy.vue?vue&type=script&lang=js&"
export * from "./ClientBidOrBuy.vue?vue&type=script&lang=js&"
import style0 from "./ClientBidOrBuy.vue?vue&type=style&index=0&id=67408dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67408dca",
  null
  
)

export default component.exports